export default "__VITE_ASSET__BmrVJOyj__"